import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';
import LoadingIndicator from './LoadingIndicator';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useProfile();
  const location = useLocation();
  
  // Debug logging
  useEffect(() => {
    console.log('ProtectedRoute - Authentication status:', isAuthenticated);
    console.log('ProtectedRoute - Is loading:', isLoading);
    console.log('ProtectedRoute - Current path:', location.pathname);
  }, [isAuthenticated, isLoading, location]);

  // Check localStorage directly as a backup
  const checkLocalStorage = () => {
    try {
      // Add direct window.localStorage check for greater reliability
      const userData = window.localStorage.getItem('user') || localStorage.getItem('user');
      console.log('Direct localStorage check result:', userData ? 'User data found' : 'No user data');
      
      if (userData) {
        const user = JSON.parse(userData);
        return !!(user && (user.id || user._id || user.username));
      }
    } catch (e) {
      console.error('Error checking localStorage:', e);
    }
    return false;
  };

  // Show loading indicator while checking auth
  if (isLoading === true) {
    return <LoadingIndicator />;
  }

  // Double-check auth status - if null or false, check localStorage directly
  if (isAuthenticated === null || isAuthenticated === false) {
    const hasStoredAuth = checkLocalStorage();
    
    console.log('ProtectedRoute - Double check auth:', 
      isAuthenticated === null ? 'Auth state is null' : 'Auth state is false', 
      'LocalStorage has user:', hasStoredAuth);
    
    if (hasStoredAuth) {
      // Has auth in localStorage but not in context - render children anyway
      console.log('ProtectedRoute - Found auth in localStorage, allowing access');
      return children;
    }
    
    // No authentication, redirect to signup
    console.log('ProtectedRoute - No authentication found, redirecting to signup');
    return <Navigate to="/signup" state={{ from: location }} replace />;
  }

  // Auth is true, render children
  console.log('ProtectedRoute - Authenticated, rendering children');
  return children;
};

export default ProtectedRoute; 